import React, { useCallback, useEffect, useState, useMemo } from "react";
import {
  Card,
  Pagination,
  Button,
  ConfigProvider,
  Input,
  Select,
  Form,
  Modal,
  Col,
  message,
} from "antd";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import { useHistory } from "react-router-dom";
import nb from "../../img/nb.png";
import "./index.scss";
import zh_CN from "antd/es/locale/zh_CN";
import { setDict } from "@/utils/storage";
const { TextArea } = Input;
const { Search } = Input;
const { Option } = Select;
function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <a>上一页</a>;
  }
  if (type === "next") {
    return <a>下一页</a>;
  }
  return originalElement;
}

export default function FinancialService(props) {
  const { select, search } = props;
  const [currentPage, setCurrentPage] = useState(1); //当前页数
  const [total, setTotal] = useState(0);
  const [searchValue, setSearchValue] = useState(""); //搜索框value值
  const [selectValue, setSelectValue] = useState("");
  const [data, setData] = useState([]);
  const [baseData, setBaseData] = useState([]);
  const [newlist, setNewlist] = useState([]);

  const handlePage = (page, pageSize) => {
    setCurrentPage(page);
  };
  const history = useHistory();
  const handleJobDetail = (id) => {
    history.push(`entrepreneurship/StartFundApplication/${id}`);
  };
  const handleStart = () => {
    history.push(`entrepreneurship/FinancialServiceDetailsNew/${newlist[0].id}`);
  };

  const initiaList = useCallback(() => {
    let select = props.select === undefined ? "" : props.select;
    let params = {
      size: 7,
      current: currentPage,
      descs: "update_time",
      epalFinanceDetailsName: props.search,
      mechanismId: select,
    };
    Http.get(Request.financialList(), { ...params }, (obj) => {
      setData(obj.data?.records || []);
      setTotal(obj.data?.total || "");
    });
  });
  const initiaListTwo = useCallback(() => {
    if (currentPage == 1) {
      let params = {
        size: 7,
        current: 1,
        // current:currentPage,
        descs: "update_time",
      };
      Http.get(Request.financialBaseList(), { ...params }, (obj) => {
        setBaseData(obj.data?.records[0] || []);
      });
    } else {
      setBaseData([]);
    }
  });

  useEffect(() => {
    Http.get(Request.getNewDict(), {}, (obj) => {
      if (obj.code == 200) {
        setDict(obj.data);
      } else {
        message.error(`${obj.msg}`);
      }
    });
	// 获取后台写死的一条基金数据
    // Http.get(Request.sybfunddetailList(), {}, (obj) => {
    //   if (obj.code == 200) {
    //     console.log("obj", obj.data);
    //     setNewlist(obj.data.records);
    //   } else {
    //     message.error(`${obj.msg}`);
    //   }
    // });
	// 获取单页面的 眉山市退役军人创业基金
	Http.get(Request.detailSinglePage('msjycy_cybf_jj'), {}, (obj) => {
	  if (obj.code == 200) {
	    console.log("眉山市退役军人创业基金", obj.data);
	    setNewlist([obj.data]);
	  } else {
	    message.error(`${obj.msg}`);
	  }
	});

    initiaList();
    initiaListTwo();
  }, [currentPage, searchValue, selectValue]);

  useEffect(() => {
    initiaList();
    initiaListTwo();
  }, [ search, select]);

  return (
    <div className={"FinancialService_app"}>
      <div className="getjob_major_thin">
        {newlist && newlist.length ? (
          <div
            onClick={() => {
              handleStart();
            }}
            className="ImbarkBase_center"
          >
            <ul className="getjob_center_total">
              <li>
                <div>
                  <i></i>
				  {/* <span>{newlist[0].fundName}</span> */}
				  <span>{newlist[0].title}</span>
                </div>
              </li>
              <li>
                {/* <span>去申请</span> */}
                <span>查看</span>
              </li>
            </ul>
          </div>
        ) : (
          ""
        )}
        {data.map((item, index) => {
          return (
            <div
              onClick={() => {
                handleJobDetail(item.id);
              }}
              className="ImbarkBase_center"
            >
              <ul className="getjob_center_total">
                <li>
                  <div>
                    <i></i>
                    <span>{item.epalFinanceDetailsName}</span>
                  </div>
                </li>
                <li>
                  {/* <span>去申请</span> */}
                  <span>查看</span>
                </li>
              </ul>
            </div>
          );
        })}
      </div>

      <ConfigProvider locale={zh_CN}>
        <Pagination
          total={total}
          itemRender={itemRender}
          showQuickJumper={{
            goButton: <Button className={"pagination_jump"}>确定</Button>,
          }}
          showTotal={(total) => `共 ${total} 条`}
          onChange={handlePage}
          showSizeChanger={false}
          current={currentPage}
          defaultPageSize={8}
          style={{
            marginTop: 14,
            paddingRight: 24,
            display: "flex",
            justifyContent: "flex-end",
          }}
        />
      </ConfigProvider>
    </div>
  );
}
